import React from 'react';
import { Pill } from '../../../../../../components/Pill';
import urls from '../../../../urls';

export interface Props {
    urls: typeof urls;
    onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
    onMouseEnter?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
    unreadCount?: number;
}

export default class OnsiteNotificationsIcon extends React.Component<Props> {
    static readonly defaultProps: Partial<Props> = {
        onClick: () => {},
        onMouseEnter: () => {},
        unreadCount: 0,
    };

    handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (this.props.onClick) this.props.onClick(e);
    };

    unreadCount() {
        const { unreadCount } = this.props;

        if (unreadCount === 0) {
            return null;
        }

        return (
            <span className="top-level-nav__item__notification-counter">
                <Pill variations={['notification', 'tiny']}>
                    {unreadCount && unreadCount > 99 ? '99+' : unreadCount}
                </Pill>
            </span>
        );
    }

    render() {
        return (
            <a
                href={this.props.urls.notifications}
                onClick={this.handleClick}
                onMouseEnter={this.props.onMouseEnter}
                className="top-level-nav__item__link"
                data-onsite-notifications-toggle
            >
                <div className="top-level-nav__item__notification-icon icon--inline">
                    {this.unreadCount()}
                </div>
            </a>
        );
    }
}
